import React from 'react';
import { useParams } from 'react-router-dom';
import { useIsMobile } from '../hooks/useIsMobile';
import { useSimulationController } from '../hooks/useSimulationController';
import SimulationTestDesktop from './SimulationTestDesktop';
import SimulationTestMobile from './SimulationTestMobile';

const HSK3SimulationTest: React.FC = () => {
  const { examLevel } = useParams<{ examLevel: string }>();
  const isMobile = useIsMobile();
  const controller = useSimulationController(examLevel);

  return isMobile ? (
    <SimulationTestMobile controller={controller} />
  ) : (
    <SimulationTestDesktop controller={controller} />
  );
};

export default HSK3SimulationTest;
